import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalOrganizationRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.ORGANIZATIONS);
  }

  async getBySlug(slug) {
    return this.table.where("slug").equals(slug).first();
  }
}
